import { createReducer } from '@reduxjs/toolkit'

import types from './types'

export { default as actions } from './actions'

const INITIAL_STATE = {
  years: undefined,
  isFetching: false,
  fetchedTime: 0,
}

export default createReducer(INITIAL_STATE, {
  [types.FETCH_CLASS_YEARS_START]: (state) => {
    state.isFetching = true
  },
  [types.FETCH_CLASS_YEARS_SUCCESS]: (state, action) => {
    state.years = action.payload.years
    state.fetchedTime = action.payload.fetchedTime
    state.isFetching = false
  },
  [types.FETCH_CLASS_YEARS_FAILURE]: (state) => {
    state.isFetching = false
  },
})
